module.exports = __webpack_public_path__ + "img/salesforce.08917b98.png";